export const polling = {
  deviceList: 5_000,
  deviceListWithSSE: 10_000,
  deviceListFallback: 5_000,
  detectedDevices: 2_500,
  deviceDetail: 15_000,
  deviceStatus: 5_000,
  commandFallback: 2_000,
  commandWithSSE: 10_000,
  activeCommands: 5_000,
  activeJobStatus: 3_000,
  onboardingCheck: 3_000,
  helperStatus: 3_000,
} as const
